import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CheckedBagIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CheckedBagGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M16.5579 20.2578H7.802C6.88403 20.2578 6.13696 19.5107 6.13696 18.5928V7.55078C6.13696 6.63281 6.88403 5.88574 7.802 5.88574H16.5579C17.4758 5.88574 18.2229 6.63281 18.2229 7.55078V18.5928C18.2229 19.5107 17.4758 20.2578 16.5579 20.2578ZM7.802 6.88574C7.4353 6.88574 7.13696 7.18359 7.13696 7.55078V18.5928C7.13696 18.96 7.4353 19.2578 7.802 19.2578H16.5579C16.9246 19.2578 17.2229 18.96 17.2229 18.5928V7.55078C17.2229 7.18359 16.9246 6.88574 16.5579 6.88574H7.802Z"
        fill={fill}
      />
      <path
        d="M14.5798 6.88574H9.78004C9.50367 6.88574 9.28004 6.66211 9.28004 6.38574V3.66504C9.28004 2.74707 10.0271 2 10.9451 2H13.4148C14.3328 2 15.0799 2.74707 15.0799 3.66504V6.38574C15.0799 6.66211 14.8562 6.88574 14.5798 6.88574ZM10.28 5.88574H14.0798V3.66504C14.0798 3.29785 13.7815 3 13.4148 3H10.9451C10.5784 3 10.28 3.29785 10.28 3.66504L10.28 5.88574Z"
        fill={fill}
      />
      <path
        d="M9.23706 17.5147C8.96069 17.5147 8.73706 17.291 8.73706 17.0147V9.1084C8.73706 8.83203 8.96069 8.6084 9.23706 8.6084C9.51343 8.6084 9.73706 8.83203 9.73706 9.1084V17.0147C9.73706 17.291 9.51343 17.5147 9.23706 17.5147Z"
        fill={fill}
      />
      <path
        d="M12.1799 17.5147C11.9036 17.5147 11.6799 17.291 11.6799 17.0147V9.1084C11.6799 8.83203 11.9036 8.6084 12.1799 8.6084C12.4563 8.6084 12.6799 8.83203 12.6799 9.1084V17.0147C12.6799 17.291 12.4563 17.5147 12.1799 17.5147Z"
        fill={fill}
      />
      <path
        d="M15.1228 17.5147C14.8464 17.5147 14.6228 17.291 14.6228 17.0147V9.1084C14.6228 8.83203 14.8464 8.6084 15.1228 8.6084C15.3992 8.6084 15.6228 8.83203 15.6228 9.1084V17.0147C15.6228 17.291 15.3992 17.5147 15.1228 17.5147Z"
        fill={fill}
      />
      <path
        d="M15.2605 22C14.7083 22 14.2605 21.5527 14.2605 21V20.3467C14.2605 19.7939 14.7083 19.3467 15.2605 19.3467C15.8128 19.3467 16.2605 19.7939 16.2605 20.3467V21C16.2605 21.5527 15.8128 22 15.2605 22Z"
        fill={fill}
      />
      <path
        d="M9.23706 22C8.68481 22 8.23706 21.5527 8.23706 21V20.3467C8.23706 19.7939 8.68481 19.3467 9.23706 19.3467C9.78931 19.3467 10.2371 19.7939 10.2371 20.3467V21C10.2371 21.5527 9.78931 22 9.23706 22Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckedBagIcon;
